export const spacing = { xs: 2, lg: 3 }
